module.exports = ".center {\n    margin-left: auto;\n    margin-right: auto;\n    display: block;\n}\n.thumbnail:hover {\n    position:relative;\n    top:-25px;\n    left:-35px;\n    width:100%;\n    height:auto;\n    display:block;\n    z-index:999;\n}\n.to_right{\n    padding-left: 10px;\n}\n.header{\n    padding-left:0px;\n    font-weight:bold;\n    font-family: roboto, arial, sans-serif;\n    display: inline;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/getting-started/getting-started.component.css
// module id = ./src/app/getting-started/getting-started.component.css
// module chunks = main